
import {cs} from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {itemEditor, ui}   from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {UYO} from "./uyo";

export const UyoModules = ({templateOptions, item, view, gallery, customizeStatus}) => [
    {
        load: ({}, next) => cs(
            ["eh", (_, next) => ErrorHighlighter({next})],
            ["domRef", (_, next) => Static2({next})],
            ({eh, domRef}) => next({
                itemEditor: {
                    $name: "uyo",

                    errorsHandling: {
                        highlightErrors: () => {
                            eh.start();
                            scrollIntoView(domRef.get());
                        },
                    },

                    valid: item?.metaData?.pdfValidation?.thumbnails?.length > 0,
                },
                ui: ({prepareSave}) => UYO({
                    templateOptions,
                    eh, domRef, item,
                    view, gallery, 
                    customizeStatus,
                    prepareSave,
                }),
            })
        ),
        expo: [itemEditor, ui("uyo")],
        requires: [],
    },
];
